import React from 'react';
import { callAirBrake } from '../config/apiSetting';

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    // Send error to Airbrake
    callAirBrake(error);
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.hasError) {
      // eslint-disable-next-line react/destructuring-assignment
      if (this.state.error.name === 'ChunkLoadError') {
        return (
          <div className="align-content-center ml-5 pl-5">
            <h4>This application has been updated, please refresh your browser to see the latest content.</h4>
          </div>
        );
      }
      return (
        <div className="align-content-center ml-auto">
          <h4>Oops! We encountered some issues here. </h4>
        </div>
      );
    }

    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}

export default ErrorBoundary;
